module.exports = {
  cache: require('./cache'),
  configuration: require('./configuration'),
  cookies: require('./cookies'),
  errors: require('./errors'),
  headers: require('./headers'),
}
